import { Tags } from "./tags.model";

export class TagGroup {
  id: number;
  name : string;
  color: string | null;
  tags: Tags[];
  constructor() {
    this.id = 0;
    this.name = "";
    this.color = null;
    this.tags = [];
  }
}


// Define a type for the input object
type CategoryMap = {
  [key: string]: string[]; // Each key is a string, each value is an array of strings
};

// Create a class that receives this structure
export class TagsFiltered {
  filters: CategoryMap;
  constructor(data: CategoryMap) {
    this.filters = data;
  }
}